<template>
  <el-form :model="form" :rules="rules" ref="form" label-position="top" class="category-attr">
    <template v-if="propConfigs.length && !formVoid">
      <template v-for="(item) in propConfigs">
         <div
          class="attr-item"
          :class="{'percent-attr-item': isPercent(item)}"
          :key="item.id">
          <el-form-item
            :prop="`${item.id}`"
            :label="item.name">
            <template v-if="isPercent(item)">
              <PercentProp :propConfig="item" :itemPropValues="values" @update="updateItemPropValues"/>
            </template>
            <el-select
              style="width: 100%"
              v-else-if="[INPUTTYPES.SINGLE_SELECT, INPUTTYPES.MULTI_SELECT].includes(item.inputType)"
              :multiple="item.inputType === INPUTTYPES.MULTI_SELECT"
              filterable
              clearable
              :value="item.inputType === INPUTTYPES.SINGLE_SELECT ? form[item.id][0] : form[item.id]"
              @change="(v) => selectChange(v, item)">
              <el-option
                v-for="(op) in item.attrValueList"
                :key="op.id"
                :label="op.name"
                :value="`${op.id}`"
              ></el-option>
            </el-select>
            <template v-else-if="isMultiUnit(item)">
              <MultiUnitProp :propConfig="item" :itemPropValues="values" @update="updateItemPropValues"/>
            </template>
            <template v-else-if="item.inputType === INPUTTYPES.CASCADER">
              <el-cascader class="width100" v-model="form[item.id]" :options="item.attrValueList" clearable :props="cascaderProps"></el-cascader>
            </template>
            <el-input v-else v-model="form[item.id][0]" clearable></el-input>
          </el-form-item>
        </div>
      </template>
      
    </template>
    <div v-else>暂无属性</div>
    <template>
      <span class="update-brand">找不到商品属性？
          <el-link :underline="false" @click="fetch_props(true)">刷新数据</el-link>
      </span>
    </template>
  </el-form>
</template>

<script>
import {getCategoryProps, _filterInvalidImg} from '@/servers/prod/center/jd.js'
import { mapActions } from 'vuex'
import PercentProp from './CategoryPropComps/PercentProp.vue';
import MultiUnitProp from './CategoryPropComps/MultiUnitProp.vue';
import { fieldFill, getCombinationInputs } from './service';

const INPUTTYPES = {
  SINGLE_SELECT: 1, // 单选 （加上 feature中包含 key 为 cascadeGroupId 的特殊属性时， 属性级联）
  MULTI_SELECT: 2, // 多选(加上 feature中包含 key为 inputPercent 值为1的特殊属性时，百分比规则)
  MULTI_INPUT: 10, // 多输入多单位组合 （前缀后缀存储在feature中，key为 combinationValue ，value的格式为：n）
  AREA_INPUT: 11, // 地域级联
  JWD_INPUT: 12, // 经纬度, 渲染出地址选择框，保存经纬度信息
  DATE_PICKER: 13, // 时间选择, 渲染成时间控件，支持选择到秒
  INPUT: 3, // 文本输入
  CASCADER: 15, // 级联选择器
}


export default {
  components: { PercentProp, MultiUnitProp },
  model: {
    prop: 'values',
    event: 'change'
  },
  props: {
    values: {
      required: true
    },
    categoryIds: {
      type: Array,
      default() {
        return []
      }
    },
    propConfigType: {
      type: String,
      default: 'item'
    }
  },
  data() {
    return {
      INPUTTYPES,
      form: {},
      formVoid: true,
      propConfigs: [], // 属性配置
      rules: {},
      categoryIdChange: false,
      categoryId: '',
      isInited: 0,
      cid: ''
    }
  },
  computed: {
    categoryIdsLen() {
      return this.categoryIds.length
    },
    cascaderProps() {
      return {
        value: 'id',
        label: 'name',
        children: 'children',
      }
    },
  },
  watch: {
 
    categoryIds: {
      handler(v) {
        this.categoryId = !v.length ? '' : v[v.length - 1]
      },
      immediate: true
    },
    categoryId: {
      handler(v, o) {
        this.propConfigs = []
        this.rules = {}
        this.categoryIdChange = !!o
        this.cid = v;
        v && this.fetch_props()
      },
      immediate: true
    },
    values: {
      immediate: true,
      handler(v) {
        if (!this.propConfigs.length) return ;
        // 根据values生产form
        if (!v || !v.length) {
          this.form = {}
          this.formVoid = true
          return;
        }
        this.formVoid = false
        v.forEach(item => {
          let _value = item.attrValues

          // // 获取当前属性值是否是输入框或单选框
          // const propItem = this.propConfigs.find(pitem => pitem.id === item.attrId)
          // if (propItem && [INPUTTYPES.SINGLE_SELECT, INPUTTYPES.INPUT].includes(item.inputType)) {
          //   // 是输入框或单选框取数组第一位
          //   _value = _value[0];
          // }

          // 避坑1：form中的attrValues必须和values中的attrValues保持相同的引用，不然values和form 2个watch会进入死循环。关联点请见“避坑2”
          this.$set(this.form, item.attrId, _value)
        })
      }
    },
    form: {
      deep: true,
      handler(v) {
        if (!this.propConfigs.length) return ;
        let _values = (this.values && this.values.length) ? JSON.parse(JSON.stringify(this.values)) : false

        if (!_values) return;
        _values = _values.map(item => {
          let _new_value = v[item.attrId] || [""]
          let _item = {
            ...item
          }
          // // 获取当前属性值是否是输入框或单选框
          const propItem = this.propConfigs.find(pitem => pitem.id === item.attrId)
          let _new_value_alias = propItem && propItem.attrValueList.filter(itemProp => _new_value.includes(itemProp.id.toString())).map(item=>item.name);
          // if (propItem && [INPUTTYPES.SINGLE_SELECT, INPUTTYPES.INPUT].includes(propItem.inputType)) {
          if (propItem && [INPUTTYPES.INPUT].includes(propItem.inputType)) {
            // 是输入框或单选框取将值用数组包裹
            _new_value_alias = _new_value;
          }

          // const propItem = this.propConfigs.find(pitem => pitem.id === item.attrId)

          // if(propItem && this.isMultiUnit(propItem)) {
          //   let fvalue = this.getCombinationInputs(propItem.features)
          //   let expands =[];
          //   let units =[];
          //   (fvalue || []).forEach(fv => {
          //     expands.push(fv.prefix);
          //     units.push(fv.unit[0]);
          //   });
          //   _item.expands = expands;
          //   _item.units = units;
          // }

          // 避坑2：关联点请见“避坑1”
          _item.attrValues = _new_value
          _item.attrValueAlias = _new_value_alias
          return _item
        })
        this.$emit('change', _values)
      }
    }
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    // 是否显示百分比属性
    isPercent(item) {
      const { features = [] } = item;
      const showPercent = features.find(it => it.key === 'inputPercent')?.fvalue == 1;
      return item.inputType == INPUTTYPES.MULTI_SELECT && showPercent;
    },
    // 是否是组合属性
    isMultiUnit(item) {
      return item.inputType === INPUTTYPES.MULTI_INPUT && getCombinationInputs(item.features);
    },
    getCombinationInputs,
    selectChange(v, item) {
      if (item.inputType === INPUTTYPES.SINGLE_SELECT) {
        this.$set(this.form[item.id], 0, v);
      } else {
        this.form[item.id] = v
      }
      this.$forceUpdate()       
    },
    async fetch_props(isUpdate) {
      isUpdate && this.updateCatePropShopIndex("jd")
      this.fetch_type4Props()
      this.fetch_type_other_props()
    },
    async fetch_type4Props() {
      if(this.propConfigType === 'sku') return
       // 4 --- 为规格值过滤条件 --- 需要暴露出去
      const c_len = this.categoryIdsLen;
      // const cid = c_len > 3 ? this.categoryIds[c_len - 2] : this.categoryIds[c_len - 1]
      const cid = this.categoryIds[c_len - 1]
      let res = await getCategoryProps({categoryId: cid, attrType: 4})
      this.$emit('prop4get', res)
    },
    async fetch_type_other_props() {
      const [res1, res2] = await Promise.all([getCategoryProps({categoryId: this.cid, attrType: 3}), getCategoryProps({categoryId: this.cid, attrType: 1})])
      const res = [...res1, ...res2]
      if (res && res.length) {
        const isSkuAttr = (item) => (item.features || []).some(f => f.key === 'attrLevel' && f.fvalue === '1')
        const includeSku = this.propConfigType !== 'item'
        let propConfigs = res.filter(item => includeSku ? isSkuAttr(item) : !isSkuAttr(item))
        if (includeSku) {
          const jdWareLocation = this.$store.getters.jd_wareLocation || []
          propConfigs.forEach(i => {
            if (i.inputType === INPUTTYPES.AREA_INPUT && i.name === '产地') {
              i.inputType = INPUTTYPES.SINGLE_SELECT
              i.attrValueList = jdWareLocation.map(loc => ({ id: loc.id, name: loc.locationName }))
            }
          })
        }
        this.propConfigs = propConfigs
        this.$emit('prop3get', res)
        this.initValues(propConfigs)
      } else {
        return false
      }
    },
    // 初始化类目属性数据结构
    initValues(propConfigs) {
      let init_values = []
      propConfigs?.forEach(item => {
        const showPercent = this.isPercent(item); // 是否显示百分比属性
        const attrValues = [INPUTTYPES.MULTI_SELECT, INPUTTYPES.CASCADER].includes(item.inputType) || showPercent ? [] : [""];
        const attrValueAlias = item.attrValueList && item.attrValueList.length ? item.attrValueList.filter((valueItem)=>item.id === valueItem.attId):[]

        let v = {
          attrId: item.id,
          attrValues,
          attrValueAlias,
          name:item.name,
        }
        if (showPercent || this.isMultiUnit(item)) {
          v.expands = [];
          v.units = [];
        }
        let oldValue = this.values && this.values.find(v => `${v.attrId}` === `${item.id}`)
        if (oldValue && !this.categoryIdChange) {
          if (showPercent) {
            // 百分比属性 expands、attrValues数组保持同样的长度，对expands补齐
            // const filledValue = fieldFill(oldValue, 'attrValues', ['expands']);
            // Object.assign(oldValue, filledValue);
            Reflect.deleteProperty(oldValue, 'attrValueAlias');
          } else if (item.inputType === INPUTTYPES.CASCADER) {
            oldValue.attrValues?.forEach((it, i) => oldValue.attrValues[i] = +it);
          }
          // 老值回显问题
          init_values.push(oldValue)
        } else {
          init_values.push(v)
        }
        this.setRulesByPropConfig(item)
      })
      if (this.categoryIdChange || !(this.values && this.values.length)) {
        this.$emit('change', init_values)
        this.categoryIdChange = false
      } else {
        this.$emit('change', init_values)
      }
    },
    // 设置单个属性的校验规格
    setRulesByPropConfig(config) {
      let rules = []
      if (config.isRequired) {
        rules.push({ required: true, message: `请完善${config.name}` })
        rules.push({ validator: (rule, value, cb) => {
          if (value.filter(Boolean).length) {
            cb()
          } else {
            cb(new Error(`请完善${config.name}`))
          }
        } })
      }

      // 百分比属性
      if (this.isPercent(config)) {
        rules.push({ validator: (rule, value, cb) => {
          let propValue = this.values.find(it => it.attrId == config.id);
          if (!propValue || !propValue.attrValues.length) {
            cb();
          } else {
            let { attrValues = [], expands = [] } = propValue;
            const hasEmptyField = attrValues.some(it => !it);
            const hasEmptyValue = expands.some(it => !it);
            if (hasEmptyField) {
              cb(new Error(`属性不得为空`));
            } else if (hasEmptyValue || (attrValues.length !== expands.length)) {
              cb(new Error(`值不得为空`));
            } else {
              cb();
            }
          }
        } });
      }

      // 组合属性
      if (this.isMultiUnit(config)) {
        rules.push({ validator: (rule, value, cb) => {
          let { attrValues = [] } = this.values.find(it => it.attrId == config.id);
          const length = (getCombinationInputs(config.features) || []).length;
          const extraValues = Array(length).fill('');
          // 从接口获取的值长度跟配置的不匹配，需要补全
          attrValues = attrValues.concat(extraValues).slice(0, length);

          const allHasValue = attrValues.every(it => !!it);
          const allNull = attrValues.every(it => !it);
          // 任意一个框有值，其他每个框都必填值；或者每个框都没值
          if (allHasValue || allNull) {
            cb();
          } else {
            cb(new Error(`请将单位和属性值填写完整`));
          }
        } });
      }
      this.$set(this.rules, config.id, rules)
    },
    // 更新外部的 itemPropValues
    updateItemPropValues(val) {
      this.$emit('change', val);
    },
  }
  
}
</script>

<style lang="scss" scoped>
.category-attr {
  background: #f9f9fa;
  padding: 10px 20px 35px 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 100px;
  align-items: flex-start;
  position: relative;
  .attr-item {
    margin: 0 20px 0px 0;
    width: 245px !important;
    // margin-bottom: 28px !important;
  }
  .percent-attr-item {
    width: 490px !important;
  }

  ::v-deep .el-form-item__label {
    padding: 0;
  }
  ::v-deep .el-input-group{
    margin-bottom: 5px;
  }
  .update-brand {
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
}
</style>
